import { TextField } from '@atoms';
import { SelectFabric } from '@molecules';
import { Checkbox, FormControlLabel } from '@mui/material';
import { FC } from 'react';
import { Controller } from 'react-hook-form';
import {
  SENTIMENT_ANALYSIS_OPTION,
  SENTIMENT_ANALYSIS_SUBCATEGORIES,
} from 'src/features/Enterprise/SentimentAnalysis/types';
import { sentimentOptions } from '../../../../features/Enterprise/SentimentAnalysis/utils';
import { NewsWireLabels } from '../../NewsWire/constants';

export type NEWS_WIRE_LABEL_OPTION = {
  value: NewsWireLabels;
  label: NewsWireLabels;
};
export interface FormData {
  title: string;
  url: string;
  imageUrl: string;
  categories?: SENTIMENT_ANALYSIS_OPTION[];
}

const AddSentimentAnalysisModalForm: FC<{
  control: any;
  categories: SENTIMENT_ANALYSIS_OPTION[];
  subCategories: SENTIMENT_ANALYSIS_SUBCATEGORIES[];
}> = ({ control, categories, subCategories }) => {
  return (
    <>
      <TextField
        name="title"
        label="Analysis Title"
        placeholder="Enter your title"
        control={control}
        sx={{ mb: '20px' }}
      />
      <TextField
        name="url"
        label="Url"
        placeholder="Enter Url"
        control={control}
        sx={{ mb: '20px' }}
      />
      <TextField
        name="imageUrl"
        label="Image Url"
        placeholder="Enter the image url"
        control={control}
        sx={{ mb: '20px' }}
      />
      <SelectFabric
        name="category"
        label="Category"
        placeholder="Select a category"
        control={control}
        options={categories}
        sx={{ mb: '30px' }}
      />
      <SelectFabric
        name="subCategory"
        label="Subcategory"
        placeholder="Select a subcategory"
        control={control}
        options={subCategories}
        sx={{ mb: '30px' }}
      />

      <SelectFabric
        name="sentiment"
        label="Sentiment"
        placeholder="Select a sentiment"
        control={control}
        options={sentimentOptions}
        sx={{ mb: '30px' }}
      />

      <TextField
        name="label"
        label="Analysis Label"
        placeholder="Enter your label"
        control={control}
        sx={{ mb: '20px' }}
      />
      <Controller
        name="isSubmitted"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox checked={field.value} onChange={field.onChange} />}
            label="Is Submitted"
          />
        )}
      />
    </>
  );
};

export default AddSentimentAnalysisModalForm;
